var _rect, _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect2, _rect3, _rect4, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 1024,
    viewBox: "0 0 750 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 750,
    height: 1024,
    fill: "#DDE6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M364.5 908C538.194 908 679 884.047 679 854.5C679 824.953 538.194 801 364.5 801C190.806 801 50 824.953 50 854.5C50 884.047 190.806 908 364.5 908Z",
    fill: "url(#paint0_linear_148_3916)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M532 634L552 634",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112 538H135",
    stroke: "#03989E",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 486.5,
    cy: 493.5,
    r: 8.5,
    fill: "#FF914D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.737 177.32C198.303 177.32 196.891 177.472 195.543 177.733C195.543 177.581 195.543 177.45 195.543 177.32C195.543 165.802 186.221 156.48 174.703 156.48C171.031 156.48 167.597 157.436 164.598 159.087C163.599 148.504 154.711 140.203 143.845 140.203C132.328 140.203 123.005 149.526 123.005 161.043C112.944 161.043 104.555 168.171 102.6 177.668C101.383 177.45 100.122 177.32 98.8401 177.32C87.3226 177.32 78 186.642 78 198.16C78 209.677 87.3226 219 98.8401 219H199.716C211.233 219 220.556 209.677 220.556 198.16C220.556 186.642 211.233 177.32 199.716 177.32H199.737Z",
    fill: "url(#paint1_linear_148_3916)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M392.515 11.7164C391.085 11.7164 389.715 11.8554 388.365 12.1334C388.365 11.9944 388.384 11.8554 388.384 11.7164C388.384 0.318232 379.151 -8.91547 367.753 -8.91547C364.119 -8.91547 360.703 -7.96232 357.744 -6.31416C356.771 -16.7989 347.935 -25 337.212 -25C325.814 -25 316.58 -15.7663 316.58 -4.36813C306.611 -4.36813 298.311 2.70112 296.365 12.0937C295.154 11.8753 293.903 11.7363 292.632 11.7363C281.234 11.7363 272 20.97 272 32.3681C272 43.7663 281.234 53 292.632 53H392.535C403.933 53 413.167 43.7663 413.167 32.3681C413.167 20.97 403.933 11.7363 392.535 11.7363L392.515 11.7164Z",
    fill: "url(#paint2_linear_148_3916)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M655.302 95.0224C653.757 95.0224 652.232 95.1829 650.788 95.4838C650.788 95.3233 650.808 95.1829 650.808 95.0224C650.808 82.6044 640.737 72.5336 628.319 72.5336C624.367 72.5336 620.656 73.5568 617.426 75.3623C616.363 63.9474 606.753 55 595.057 55C582.639 55 572.569 65.0708 572.569 77.4888C561.715 77.4888 552.668 85.1723 550.541 95.4036C549.217 95.1628 547.873 95.0224 546.489 95.0224C534.071 95.0224 524 105.093 524 117.511C524 129.929 534.071 140 546.489 140H655.302C667.72 140 677.79 129.929 677.79 117.511C677.79 105.093 667.72 95.0224 655.302 95.0224Z",
    fill: "url(#paint3_linear_148_3916)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.035 674H331.965C350.795 674 366 689.687 366 708.932V862H86V708.932C86 689.606 101.284 674 120.035 674Z",
    fill: "#4E4E4E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M293.311 390.03C279.717 387.036 262.725 390.596 250.75 400.387C238.694 410.177 230.036 430.972 227.932 446.346C227.285 450.958 227.285 455.732 225.99 460.263C222.106 474.261 207.703 482.514 200.017 494.894C191.925 507.921 192.249 525.803 201.069 538.345C209.888 550.887 226.637 557.36 241.526 553.638C245.086 552.748 248.484 551.372 251.478 549.268C255.443 546.517 258.598 542.633 261.026 538.426C272.03 519.33 268.713 495.703 271.14 473.776C273.082 456.055 279.07 438.821 288.537 423.69C291.288 419.32 294.443 414.87 295.252 409.773C296.062 404.675 293.715 398.526 288.779 397.15",
    fill: "#1E1E1F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M276.701 392.699C311.252 379.348 350.171 415.921 321.366 455.488C321.285 455.569 321.204 455.731 321.123 455.812C317.725 460.99 314.003 466.088 311.98 471.833C311.009 474.745 310.604 477.82 311.252 480.652C311.899 483.484 313.517 486.073 315.54 488.177C317.563 490.362 320.152 492.304 322.418 494.731C324.764 497.159 326.706 499.991 328.163 502.984C331.076 509.053 331.804 516.335 329.943 523.051C325.978 536.159 314.731 546.759 301.056 549.267C297.658 549.834 294.098 549.915 290.699 549.348C287.22 548.863 283.984 547.325 281.233 546.112C275.488 543.765 269.419 541.742 263.512 539.234L263.674 538.668C269.985 539.719 276.216 540.69 282.527 542.39C285.764 543.28 288.434 544.251 291.347 544.412C294.179 544.574 297.092 544.412 299.924 543.684C305.588 542.309 310.847 539.558 315.378 535.755C319.909 532.033 323.632 527.097 325.493 521.595C327.354 516.092 327.03 509.943 324.683 504.441C323.551 501.69 321.932 499.181 319.99 496.916C317.968 494.65 315.54 492.627 313.355 490.038C311.171 487.53 309.472 484.374 308.905 480.976C308.339 477.577 309.067 474.098 310.281 471.104C311.171 468.92 312.304 466.978 313.517 465.036C307.853 472.237 303.322 480.328 309.067 488.501C312.384 493.194 316.754 496.188 318.939 501.771C321.123 507.273 321.609 513.503 319.99 519.167C315.055 536.726 289.729 546.516 273.788 537.939C267.234 534.379 260.033 531.628 253.155 528.553C251.213 527.663 223.945 516.173 224.188 515.526L252.67 414.707L276.54 392.537L276.701 392.699Z",
    fill: "#1E1E1F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M470.174 840.559H482.068L474.381 804.229H457.065L470.174 840.559Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M484.989 836.379L475.441 840.506L466.702 836.379L458.772 862.19H532L504.489 849.244L484.989 836.379Z",
    fill: "#4B5397"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M381.242 840.559H393.137L402.199 804.229H384.802L381.242 840.559Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M396.048 836.379L386.5 840.506L377.762 836.379L369.832 862.19H443.059L415.548 849.244L396.048 836.379Z",
    fill: "#4B5397"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.514 673.634H280.273L272.263 627.027L430.773 637.87C448.089 641.025 460.631 656.075 460.631 673.634H460.55H460.549L460.55 673.634L477.784 816.771H460.469L406.514 673.634Z",
    fill: "#0C3F86"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.226 605.988C216.805 609.046 215.181 612.378 213.197 616.45C209.09 624.877 203.441 636.47 203.714 655.346C203.956 672.095 215.042 682.533 227.583 688.116C238.102 692.809 249.835 693.861 261.244 692L372.087 673.633H372.362L382.649 816.77H399.965L429.418 673.633L429.418 673.633H429.496C429.496 656.075 416.954 641.025 399.638 637.869L307.883 627.027L307.769 626.945L217.226 605.988Z",
    fill: "#0F4590"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.076 611.157L323.079 611.167L405.287 622.334V609.064L333.07 588.901L305.281 509.054C302.125 499.021 282.948 491.253 273.4 495.784C263.853 500.315 260.616 512.291 266.442 521.11L310.297 605.099L310.353 605.072C310.86 605.856 311.456 606.598 312.141 607.283C315.123 610.265 319.171 611.556 323.076 611.157Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.684 612.233L214.652 612.381L214.571 612.219L214.684 612.233ZM285.576 488.64C285.348 488.589 285.118 488.543 284.885 488.502L222.5 482.595C213.357 480.977 204.861 487.612 204.214 496.917L219.83 588.673L214.684 612.233L281.001 619.906L288.483 567.761L288.921 568.607L322.176 550.239L305.023 503.067C301.87 494.578 294.082 489.179 285.576 488.64Z",
    fill: "#FFDE59"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M425.43 637.626L296.534 630.91V627.674L425.43 634.39V637.626Z",
    fill: "#333333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M429.734 634.391L343.723 631.073L367.026 568.607H453.118L429.734 634.391Z",
    fill: "#333333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.236 600.155L182.214 600.15L201.391 504.509C201.957 493.909 207.783 489.459 218.14 491.563C228.497 493.667 239.178 511.387 235.617 521.339L212.243 594.522L279.713 613.421L299.051 611.722L318.875 627.014L279.713 626.61L193.782 615.687L193.766 615.532C187.948 614.718 183.094 610.123 182.225 604.034C182.036 602.715 182.048 601.412 182.236 600.155Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M225.322 558.654L192.39 548.055L200.562 499.911C203.232 486.075 217.878 478.064 230.905 483.404C242.071 487.936 247.573 500.558 243.446 511.805L225.322 558.574V558.654Z",
    fill: "#FFDE59"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.464 484.705C251.361 476.251 261.54 458.855 263.43 457.025L279.613 472.318L274.673 487.652L278.836 488.087L263.409 520.721L239.082 483.934L246.464 484.705Z",
    fill: "#F3F3F3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M307.553 425.227C308.929 434.694 311.033 438.577 309.738 445.779C308.154 449.966 306.62 454.084 305.045 458.32C300.676 469.891 287.81 475.798 276.159 471.428C264.588 467.059 258.681 454.194 263.051 442.542L266.934 432.266C273.569 423.366 297.034 436.959 307.553 425.227Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M271.986 437.446C270.487 441.492 265.992 443.515 261.946 442.016C257.9 440.518 255.877 436.022 257.376 431.976C258.874 427.93 263.37 425.907 267.415 427.406C271.461 428.904 273.484 433.4 271.986 437.446Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 434,
    y: 207,
    width: 244,
    height: 224,
    fill: "#0036CD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 197,
    width: 244,
    height: 224,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 227,
    width: 70,
    height: 70,
    fill: "#F0F7FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M542 254H592",
    stroke: "#03989E",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M542 274.5H627",
    stroke: "#D2E5FB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M451 326H575",
    stroke: "#D2E5FB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M451 356H644",
    stroke: "#D2E5FB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M451 387H644",
    stroke: "#D2E5FB",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.644 252.54C470.644 247.101 474.665 243 479.997 243C485.329 243 489.349 247.101 489.349 252.54C489.349 258.138 485.154 262.691 479.997 262.691C474.84 262.691 470.644 258.138 470.644 252.54ZM462 280.222C462 270.251 468.393 264.76 480 264.76C491.607 264.76 498 270.252 498 280.222C498 281.001 497.369 281.632 496.59 281.632H463.41C462.631 281.632 462 281.001 462 280.222Z",
    fill: "#CCD7F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_148_3916",
    x1: 364.5,
    y1: 801,
    x2: 364.5,
    y2: 908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.367451,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_148_3916",
    x1: 149.278,
    y1: 140.203,
    x2: 149.278,
    y2: 219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_148_3916",
    x1: 342.583,
    y1: -25,
    x2: 342.583,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_148_3916",
    x1: 600.895,
    y1: 55,
    x2: 600.895,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE6FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.6b0128c0056d968dc07f462f2c9c2a73.svg";
export { ForwardRef as ReactComponent };